import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { qualifierToJson } from "./qualifierToJson.js";
export var QualifierModel = /*#__PURE__*/function () {
  function QualifierModel() {
    _classCallCheck(this, QualifierModel);
    this._qualifierModel = {};
  }
  return _createClass(QualifierModel, [{
    key: "toJson",
    value: function toJson() {
      return qualifierToJson.apply(this);
    }
  }]);
}();